export const COLOR_SECTION_GRAY = "rgba(229, 228, 226, 0.5)"
export const COLOR_LOGIN_CARD_BLACK = "rgba(0,0,0,0.5)"
export const COLOR_WHITE_WITH_KINDA_TRANSPARENCY = "rgba(255,255,255,0.1)"
export const COLOR_BLACK = "#000"
export const COLOR_WHITE = "#fff"
export const COLOR_LIGHT_GRAY = "#707070"
export const COLOR_MAIN_COLOR_BLUE = "#002aff"